import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LockKeyhole } from "lucide-react";
import GBAMMissionAssurancePreview from "./GBAMMissionAssurancePreview";

const LEGACY_COMPONENT_ACCESS_KEY = "DIU-PROJ00672-VS-7A24C9D6";

function LoadingState() {
  return (
    <main className="flex min-h-[70vh] items-center justify-center bg-[#071525] px-6 text-white">
      <div className="rounded-2xl border border-cyan-300/20 bg-[#0b1f35] px-7 py-6 text-center shadow-xl">
        <LockKeyhole
          className="mx-auto h-7 w-7 text-cyan-300"
          aria-hidden="true"
        />
        <p className="mt-4 text-sm font-semibold tracking-wide text-slate-200">
          Verifying reviewer session…
        </p>
      </div>
    </main>
  );
}

export default function GBAMProtectedReview() {
  const navigate = useNavigate();
  const [authorized, setAuthorized] = useState(false);

  useEffect(() => {
    let active = true;

    fetch("/api/gbam-session", {
      method: "GET",
      credentials: "include",
      cache: "no-store",
      headers: { Accept: "application/json" },
    })
      .then((response) => {
        if (!active) return;
        if (!response.ok) {
          navigate("/g-bam-mission-assurance-preview", { replace: true });
          return;
        }

        const url = new URL(window.location.href);
        if (url.searchParams.get("access") !== LEGACY_COMPONENT_ACCESS_KEY) {
          url.searchParams.set("access", LEGACY_COMPONENT_ACCESS_KEY);
          window.history.replaceState(
            window.history.state,
            "",
            `${url.pathname}${url.search}${url.hash}`
          );
        }
        setAuthorized(true);
      })
      .catch(() => {
        if (active) {
          navigate("/g-bam-mission-assurance-preview", { replace: true });
        }
      });

    return () => {
      active = false;
    };
  }, [navigate]);

  if (!authorized) return <LoadingState />;
  return <GBAMMissionAssurancePreview />;
}
